// extracted by mini-css-extract-plugin
export default {"img_div":"Card_img_div__f2Y13","img":"Card_img__8Ehvv","card_container":"Card_card_container__q59ZA"};